import { render, staticRenderFns } from "./FraudRulesPage.vue?vue&type=template&id=76d5d306&scoped=true&"
import script from "./FraudRulesPage.vue?vue&type=script&lang=js&"
export * from "./FraudRulesPage.vue?vue&type=script&lang=js&"
import style0 from "./FraudRulesPage.vue?vue&type=style&index=0&id=76d5d306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5d306",
  null
  
)

export default component.exports